import React from 'react';
import { Helmet } from 'react-helmet-async';
import HTMLHero from '../components/HTMLHero';
import HTMLGenerator from '../components/HTMLGenerator';
import HTMLFeatures from '../components/HTMLFeatures';
import HTMLHowItWorks from '../components/HTMLHowItWorks';
import HTMLTestimonials from '../components/HTMLTestimonials';
import HTMLGuide from '../components/HTMLGuide';
import HTMLSEOContent from '../components/HTMLSEOContent';
import HTMLFAQ from '../components/HTMLFAQ';
import HTMLCallToAction from '../components/HTMLCallToAction';

export default function HTMLGeneratorPage() {
  return (
    <>
      <Helmet>
        <title>HTML Generator | Create Clean, Semantic HTML Code</title>
      </Helmet>
      <HTMLHero />
      <HTMLGenerator />
      <HTMLFeatures />
      <HTMLHowItWorks />
      <HTMLTestimonials />
      <HTMLGuide />
      <HTMLSEOContent />
      <HTMLFAQ />
      <HTMLCallToAction />
    </>
  );
}